import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input, Switch } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingFormValue } from '../../model';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { InclusionToggle } from './InclusionToggle';
import { TargetingSection } from './TargetingSection';

export function SpecialHandlingTargetingSection({
  updateField,
  value,
}: {
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  const fields = [
    ['reqWithoutDeviceIfa', 'integrations.targeting.reqWithoutDeviceIfa'],
    ['reqWithoutAppStoreUrl', 'integrations.targeting.reqWithoutAppStoreUrl'],
    ['reqFilterOutInstlNotEq1', 'integrations.targeting.reqFilterOutInstlNotEq1'],
    ['reqWithoutContentChannel', 'integrations.targeting.reqWithoutContentChannel'],
    ['reqWithoutContentNetwork', 'integrations.targeting.reqWithoutContentNetwork'],
  ] as const;
  return (
    <TargetingSection title={dashboardT('integrations.targeting.specialHandling')}>
      <div className="grid gap-3 md:grid-cols-2">
        {fields.map(([field, label]) => (
          <label
            key={field}
            className="flex items-center justify-between gap-4 rounded-md border p-3 text-sm"
          >
            <span>{dashboardT(label)}</span>
            <Switch
              checked={value[field]}
              onCheckedChange={(checked) => {
                updateField(field, checked);
              }}
            />
          </label>
        ))}
      </div>
    </TargetingSection>
  );
}

export function ExtraParametersTargetingSection({
  updateField,
  value,
}: {
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  return (
    <TargetingSection
      title={dashboardT('integrations.targeting.extraParameters')}
      action={
        <InclusionToggle
          included={!value.xpExcluded}
          onIncludedChange={(included) => {
            updateField('xpExcluded', !included);
          }}
        />
      }
    >
      <div className="grid gap-3 md:grid-cols-2">
        {(['xp1', 'xp2', 'xp3', 'xp4'] as const).map((field) => (
          <DashboardPageFormField key={field} label={field.toUpperCase()}>
            <Input
              value={value[field]}
              onChange={(event) => {
                updateField(field, event.target.value);
              }}
            />
          </DashboardPageFormField>
        ))}
      </div>
    </TargetingSection>
  );
}
